import { faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import {
	Button,
	Form,
	FormControl,
	InputGroup
} from 'vio-components';
import { sortAlphabetically } from 'vio-libs';

import { IMapFeatureSources, IMapFeatureSource } from '../../interfaces';

interface IFiberMenuProps extends IMapFeatureSources {
	resetHiddenSources: () => void;
	toggleVisibility: (source: IMapFeatureSource, sources?: Array<IMapFeatureSource>) => void;
}

export const FiberMenu: React.FC<IFiberMenuProps> = ({
	hiddenSources = [],
	resetHiddenSources,
	sources = [],
	toggleVisibility
}): JSX.Element => {
	const [ filterValue, setFilterValue ] = useState('');

	const filterFibers = (source: IMapFeatureSource): IMapFeatureSource => {
		if (filterValue && filterValue.length > 0) {
			return source.name.toLowerCase().indexOf(filterValue.toLowerCase()) > -1 ? source : null;
		}

		return source;
	};

	const renderSources = (): Array<JSX.Element> => {
		let sortedSources = [ ...sources ].filter(filterFibers);

		if (sortedSources && sortedSources.length > 1) {
			sortedSources = sortedSources.sort((firstSource, secondSource) => sortAlphabetically(firstSource.name, secondSource.name));
		}

		return sortedSources.map((source, idx) => {
			const isHidden = () => {
				return hiddenSources.includes(source);
			};

			return (
				<Button
					key={ `fiber-${idx}` }
					className={ classNames('source d-block ps-0', { selected: isHidden() }) }
					onClick={ () => toggleVisibility(source) }
					variant='link'>
					<FontAwesomeIcon icon={ isHidden() ? faEyeSlash : faEye } className='me-2' />
					{ source.name }
				</Button>
			);
		});
	};

	return (
		<div id='fiber-panel' className='container'>
			<h4 className='mb-4'>Fiber Visibility</h4>

			<Form>
				<div className='mb-3 d-flex justify-content-between align-items-stretch'>
					<InputGroup className='sources-filter me-4'>
						<FormControl
							id='filter'
							placeholder='Filter fibers'
							value={ filterValue }
							onChange={ (evt: React.ChangeEvent<HTMLInputElement>) => {
								const val = evt.target.value;

								setFilterValue(val);
							} }/>

						<Button
							className='clear'
							variant='dark'
							onClick={ () => setFilterValue('') }
							size='sm'>
							<FontAwesomeIcon icon={ faTimes }/>
						</Button>
					</InputGroup>

					{ hiddenSources.length === 0 && <Button
						className='hide-all'
						disabled={ filterValue.length > 0 }
						onClick={ () => toggleVisibility(null, [ ...sources ]) }
						variant='dark'
						size='sm'>
						<FontAwesomeIcon icon={ faEyeSlash } /> Hide All
					</Button> }

					{ hiddenSources.length > 0 && <Button
						className='show-all'
						disabled={ filterValue.length > 0 }
						onClick={ resetHiddenSources }
						variant='dark'
						size='sm'>
						<FontAwesomeIcon icon={ faEye } /> Show All
					</Button> }
				</div>
			</Form>

			{ renderSources() }
		</div>
	);
};

export default FiberMenu;
